export default function MiniChart({ value, height = 10 }) {
    return (
        <div className="w-[60px] max-w-[60px] min-w-[60px] bg-gray-300 rounded" style={{direction:"ltr", height: `${height}px` }}>
            <div className="bg-[#5b5cff] rounded" style={{ width: `${(((value / 5) * 100) * 60) / 100}px`, height: `${height}px` }}></div>
        </div>
    )
}